import schema from '../../TrocarPlano/Formulario/schema';

import { cloneObject } from '../../../../utils';

function trocaPlano(form) {
    const dadosForm = cloneObject(schema);

    dadosForm.carteirinha = form.busca.carteirinha;
    dadosForm.novosPlanos = form.busca.novosPlanos;
    dadosForm.nomeCompleto = form.busca.nomeCompleto;

    dadosForm.newHealthPlan.value = form.form.novoPlanoSelecionado;
    dadosForm.date.value = form.form.dataMigracao;
    dadosForm.city.value = form.form.codigoMunicipio;
    dadosForm.state.value = form.form.codigoEstado;

    return dadosForm;
}

export { trocaPlano };
